import { defineMessages } from 'react-intl';

export default defineMessages({
  confirm: 'Are you sure to want to delete admin?',
  title: 'List of Admins',
  titleName: 'List of Admins for {name}',
  unknownError: 'Something wrong happens',
  superAdmin: 'Super Admin'
});
